import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { IdType } from "../type";

export const useFocusSpinId = (type: IdType, id: string) => {
  const location = useLocation();
  const [scroll, setScroll] = useState(false);

  const focusSpinId =
    location.hash.slice(1) ||
    (type === IdType.Spins && id) ||
    (type === IdType.BetBatches && id);

  useEffect(() => {
    if (focusSpinId && !scroll) {
      const element = document.getElementById(focusSpinId);
      element?.scrollIntoView();
      setScroll(true);
    }
  }, [focusSpinId, scroll]);

  return focusSpinId;
};
